// Homepage landing js
let videoClosed = false;

function getQueryParams(url) {
    let query = new URL(url);
    return query.hostname;
}

function handleVideoPopupOpen() {
    let element = null;
    let url = "";

    if ($("#video-desktop-hero").is(":visible") || $("#video-mobile-hero").is(":visible")) {
        element = $("#video-desktop-hero").is(":visible")
            ? $("#video-desktop-hero")
            : $("#video-mobile-hero");
        url = element.find("source").attr("src");
    } else if ($("#youtube-desktop-hero").is(":visible") || $("#youtube-mobile-hero").is(":visible")) {
        element = $("#youtube-desktop-hero").is(":visible")
            ? $("#youtube-desktop-hero")
            : $("#youtube-mobile-hero");
        url = element.attr("src");
    }

    const provider = getQueryParams(url);

    $("#video-modal").data("provider", provider);
    $("#video-modal").data("url", url);
    videoClosed = false;

    window.dataLayer.push({
        event: 'video_popup_open',
        video_provider: provider,
        video_url: url
    });
}

function handleVideoPopupClose() {
    if (videoClosed) return;
    videoClosed = true;

    const provider = $("#video-modal").data("provider") || "";
    const url = $("#video-modal").data("url") || "";

    window.dataLayer.push({
        event: 'video_popup_close',
        video_provider: provider,
        video_url: url
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const desktopBg = document.getElementById('desktop-bg'); 
    const mobileBg = document.getElementById('mobile-bg'); 
    const backgroundVideo = document.getElementById('background-video'); 
    const desktopVideoSource = document.getElementById('desktopVideoSource'); 
    const mobileVideoSource = document.getElementById('mobileVideoSource');
    const mobileVideoSource2 = document.getElementById('mobileVideoSource-2');

    const playPauseBtn = document.getElementById('playPauseBtn');
    const videocontrols = document.getElementById('video-controls-id');

    const openModalButton = document.getElementById("watch-video");
    const modal = document.getElementById("video-modal");
    const closeModalButton = document.getElementById("close-modal");

    const youtubeDesktop = document.getElementById("youtube-desktop-hero");
    const youtubeMobile = document.getElementById("youtube-mobile-hero");

    const videoDesktop = document.getElementById("video-desktop-hero");
    const videoMobile = document.getElementById("video-mobile-hero");

    const desktopImageUrl = desktopBg?.getAttribute('data-url'); 
    const mobileImageUrl = mobileBg?.getAttribute('data-url'); 

    let currentVideoSource = '';
    let isPopupVisible = false;

    function isAndroidEdge() {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.includes('android') && userAgent.includes('edg');
    }
    
    function isIphone() {
        return /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    function isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    function updateMedia() {
        const isMobile = window.innerWidth <= 767;
        let newVideoSource = '';

        if (isMobile) {
            if (mobileVideoSource?.getAttribute('src')) {
                if ((isAndroidEdge() || isIphone()) && mobileVideoSource2?.getAttribute('src')) {
                    newVideoSource = mobileVideoSource2.src;
                } else {
                    newVideoSource = mobileVideoSource.src;
                }

                if (currentVideoSource !== newVideoSource) {
                    backgroundVideo.src = newVideoSource;
                    backgroundVideo.load();
                }

                if (isIOS()) {
                    backgroundVideo.setAttribute('playsinline', 'true');
                    backgroundVideo.setAttribute('muted', 'true');
                    backgroundVideo.play();
                }
    
                backgroundVideo.style.display = 'block';
                desktopBg.style.display = 'none';
                mobileBg.style.display = 'none';
                videocontrols.style.display = 'block';
            } else {
                backgroundVideo.style.display = 'none';
                mobileBg.style.display = 'block';
                desktopBg.style.display = 'none';
                mobileBg.style.backgroundImage = `url('${mobileImageUrl}')`;
                videocontrols.style.display = 'none';
            }
        } else {
            if (desktopVideoSource?.getAttribute('src')) {
                newVideoSource = desktopVideoSource.src;

                if (currentVideoSource !== newVideoSource) {
                    backgroundVideo.src = newVideoSource;
                    backgroundVideo.load();
                }
                backgroundVideo.style.display = 'block';
                mobileBg.style.display = 'none';
                desktopBg.style.display = 'none';
                videocontrols.style.display = 'block';
            } else {
                backgroundVideo.style.display = 'none';
                desktopBg.style.display = 'block';
                mobileBg.style.display = 'none';
                desktopBg.style.backgroundImage = `url('${desktopImageUrl}')`;
                videocontrols.style.display = 'none';
            }
        }

        currentVideoSource = newVideoSource;
    }

    if (backgroundVideo && playPauseBtn) {
        playPauseBtn.addEventListener('click', () => {
            const playImg = playPauseBtn.querySelector('.play-btn');
            const pauseImg = playPauseBtn.querySelector('.pause-btn');
            if (backgroundVideo.paused) {
                backgroundVideo.play();
                playImg.style.display = 'none';
                pauseImg.style.display = 'block';
            } else {
                backgroundVideo.pause();
                playImg.style.display = 'block';
                pauseImg.style.display = 'none';
            }
        });
    }

    function getViewportWidth() {
        return window.innerWidth || document.documentElement.clientWidth;
    }

    function renderIframe() {
        const isMobile = getViewportWidth() < 768;
    
        if (isPopupVisible) {
            [youtubeDesktop, youtubeMobile].forEach((iframe) => {
                if (iframe) {
                    iframe.classList.add("hide");
                    let originalSrc = iframe.getAttribute("src").replace("&autoplay=1", "");
                    iframe.setAttribute("src", originalSrc);
                }
            });
    
            if (isMobile) {
                if (youtubeMobile && youtubeMobile.getAttribute("src").trim() !== "") {
                    let mobileSrc = youtubeMobile.getAttribute("src");
                    if (!mobileSrc.includes("&autoplay=1")) {
                        mobileSrc += "&autoplay=1";
                        youtubeMobile.setAttribute("src", mobileSrc);
                    }
                    youtubeMobile.classList.remove("hide");
                } else if (youtubeDesktop && youtubeDesktop.getAttribute("src").trim() !== "") {
                    let desktopSrc = youtubeDesktop.getAttribute("src");
                    if (!desktopSrc.includes("&autoplay=1")) {
                        desktopSrc += "&autoplay=1";
                        youtubeDesktop.setAttribute("src", desktopSrc);
                    }
                    youtubeDesktop.classList.remove("hide");
                }
            } else {
                if (youtubeDesktop && youtubeDesktop.getAttribute("src").trim() !== "") {
                    let desktopSrc = youtubeDesktop.getAttribute("src");
                    if (!desktopSrc.includes("&autoplay=1")) {
                        desktopSrc += "&autoplay=1";
                        youtubeDesktop.setAttribute("src", desktopSrc);
                    }
                    youtubeDesktop.classList.remove("hide");
                }
            }
        } else {
            [youtubeDesktop, youtubeMobile].forEach((iframe) => {
                if (iframe) {
                    let currentSrc = iframe.getAttribute("src").replace("&autoplay=1", "");
                    iframe.setAttribute("src", currentSrc);
                    iframe.classList.add("hide");
                }
            });
        }
    }
    
    function renderVideos() {
        const isMobile = getViewportWidth() < 768;

        [videoDesktop, videoMobile].forEach((video) => {
            if (video) {
                video.classList.add("hide");
                video.pause();
                video.currentTime = 0;
            }
        });

        if (isMobile && videoMobile) {
        const mobileSrc = videoMobile.querySelector("source")?.getAttribute("src") || "";
            if (mobileSrc.trim() !== "") {
                videoMobile.classList.remove("hide");
                videoMobile.play();
            } else if (videoDesktop) {
                videoDesktop.classList.remove("hide");
                videoDesktop.play();
            }
        } else if (videoDesktop) {
            const desktopSrc = videoDesktop.querySelector("source")?.getAttribute("src") || "";
            if (desktopSrc.trim() !== "") {
                videoDesktop.classList.remove("hide");
                videoDesktop.play();
            }
        }
    }

    function closeModalVideo() {
        modal.classList.add("hidden");

        [videoDesktop, videoMobile].forEach((video) => {
            if (video && !video.classList.contains("hide")) {
                video.pause();
                video.currentTime = 0;
            }
        });
    }

    function closeModalIframe() {
        isPopupVisible = false;
        modal.classList.add("hidden");

        [youtubeDesktop, youtubeMobile].forEach((iframe) => {
            if (iframe) {
                let currentSrc = iframe.getAttribute("src").replace("&autoplay=1", "");
                iframe.setAttribute("src", currentSrc);
                iframe.classList.add("hide");
            }
        });
    }

    openModalButton.addEventListener("click", (e) => {
        e.preventDefault();
        isPopupVisible = true;
        modal.classList.remove("hidden");
        renderIframe();
        renderVideos();
    });

    closeModalButton.addEventListener("click", closeModalVideo);
    closeModalButton.addEventListener("click", closeModalIframe);

    modal.addEventListener("click", (e) => {
        if (e.target === modal) {
            closeModalIframe();
            closeModalVideo();
        }
    });

    backgroundVideo?.addEventListener('canplaythrough', function () {
        backgroundVideo.classList.add('visible');
    });

    backgroundVideo?.addEventListener('loadstart', function () {
        backgroundVideo.classList.remove('visible');
    });

    backgroundVideo?.addEventListener('loadeddata', function () {
        setTimeout(() => {
            backgroundVideo.classList.add('visible');
        }, 500);
    });

    updateMedia();
    window.addEventListener('resize', updateMedia);
    window.addEventListener("resize", renderVideos);
    window.addEventListener("resize", () => {
        if (isPopupVisible) {
            renderIframe();
        }
    });

    // Events
    $(document).on("click", ".watch-video", handleVideoPopupOpen);
    $(document).on("click", "#close-modal, #video-modal", handleVideoPopupClose);
});
